import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { parseQsItems, objToQs, parseQsMoney } from '../utils'
import { getNewSwap } from '../selectors'
import {
  loadNewSwap,
  unloadNewSwap,
  newSwapSetMoneyProponente,
  newSwapAddItemProponente,
  newSwapAddItemDestinatario,
  newSwapRemoveItemProponente,
  newSwapRemoveItemDestinatario,
  createNewSwap,
} from '../actions'

import Spinner from '../common/Spinner'
import ErrorPage from '../common/ErrorPage'
import Swap from '../common/Swap'

class NewSwap extends PureComponent {
  componentDidMount() {
    this.loadNewSwap(
      this.props.match.params.destinatarioId,
      this.props.location
    )
  }

  componentWillReceiveProps(nextProps) {
    // Reload when new destinatario
    if (
      this.props.match.params.destinatarioId !==
      nextProps.match.params.destinatarioId
    ) {
      this.props.unloadNewSwap()
      this.loadNewSwap(
        nextProps.match.params.destinatarioId,
        nextProps.location
      )
    }

    // Keep query string synched \w swap
    if (
      nextProps.swap &&
      this.props.swap &&
      this.props.swap.destinatario.id === nextProps.swap.destinatario.id &&
      (nextProps.swap.destinatarioItemsIds !==
        this.props.swap.destinatarioItemsIds ||
        nextProps.swap.proponenteItemsIds !==
          this.props.swap.proponenteItemsIds ||
        nextProps.swap.proponenteMoney !== this.props.swap.proponenteMoney)
    ) {
      const queryString = objToQs({
        items: nextProps.swap.destinatarioItemsIds.join(','),
        givenItems: nextProps.swap.proponenteItemsIds.join(','),
        money: nextProps.swap.proponenteMoney,
      })
      this.props.history.replace(
        `/swap/new/${nextProps.swap.destinatario.id}?${queryString}`
      )
    }

    // New swap created goodbye
    if (nextProps.swap && nextProps.swap.id) {
      this.props.history.replace(`/swap/${nextProps.swap.id}`)
    }
  }

  componentWillUnmount() {
    this.props.unloadNewSwap()
  }

  loadNewSwap = (destinatarioId, location) => {
    const destinatarioItemsIds = parseQsItems(location, 'items')
    const proponenteItemsIds = parseQsItems(location, 'givenItems')
    const money = parseQsMoney(location, 'money')
    this.props.loadNewSwap(
      destinatarioId,
      destinatarioItemsIds,
      proponenteItemsIds,
      money
    )
  }

  handleCreateNewSwap = () => this.props.createNewSwap(this.props.swap)

  render() {
    const {
      user,
      swap,
      loading,
      creating,
      error,
      newSwapSetMoneyProponente,
      newSwapAddItemProponente,
      newSwapAddItemDestinatario,
      newSwapRemoveItemProponente,
      newSwapRemoveItemDestinatario,
    } = this.props

    if (!swap && loading) {
      return <Spinner centered />
    }

    if (!swap && error) {
      return <ErrorPage error={error} />
    }

    return (
      <div className="padding">
        {swap &&
          <div>
            <Swap
              editable={true}
              user={user}
              swap={swap}
              onSwap={this.handleCreateNewSwap}
              performingAction={creating}
              setMoneyProponente={newSwapSetMoneyProponente}
              addItemDestinatario={newSwapAddItemDestinatario}
              addItemProponente={newSwapAddItemProponente}
              removeItemDestinatario={newSwapRemoveItemDestinatario}
              removeItemProponente={newSwapRemoveItemProponente}
            />
          </div>}
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  user: state.auth.user,
  swap: getNewSwap(state),
  creating: state.newSwap.creating,
  loading: state.newSwap.loading,
  error: state.newSwap.error,
})

export default connect(mapStateToProps, {
  loadNewSwap,
  unloadNewSwap,
  newSwapSetMoneyProponente,
  newSwapAddItemProponente,
  newSwapAddItemDestinatario,
  newSwapRemoveItemProponente,
  newSwapRemoveItemDestinatario,
  createNewSwap,
})(NewSwap)



// WEBPACK FOOTER //
// ./src/pages/NewSwap.js